






























import Enumerable from "linq";
import { Mixins, Component } from "vue-property-decorator";
import { ModelEditableMixin, DialogMixin } from "../../../../../../../base/components/system/mixins";
import { IFormatObjectEditable } from "../../../../../../domain/editableFormat";
import { FormatPageStructureEditableMixin } from "../../../mixins";

@Component
export default class NamedObjectsSelectDialog extends Mixins(DialogMixin, ModelEditableMixin, FormatPageStructureEditableMixin) {
  data() {
    return {
      name: "",
    };
  }
  name: string;

  async show(): Promise<void> {
    return this.showModal(async () => { 
      await this.waitHidden();
    });
  }

  async confirm(): Promise<void> {
    await this.selectMatchedObjects();
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }

  private async selectMatchedObjects(): Promise<void> {
    this.deselectAllObjects();
    if (!this.name) {
      return;
    }
    await this.$nextTick();
    this.selectObjects(...Enumerable.from(this.objects).where(p => this.isNameMatched(p)).toArray());
  }

  private isNameMatched(object: IFormatObjectEditable): boolean {
    const name = object.name().getValue();
    return name
        && (0 <= name.indexOf(this.name));
  }
}
